import React from 'react';
import { IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { ResponsiveButton } from './ResponsiveButton';

interface ClearAllButtonProps {
  isMobile?: boolean;
  isTablet?: boolean;
  onClearAll: () => void;
}

export const ClearAllButton: React.FC<ClearAllButtonProps> = ({
  isMobile = false,
  isTablet = false,
  onClearAll,
}) => {
  const { t } = useTranslation();

  return (
    <ResponsiveButton
      isMobile={isMobile}
      isTablet={isTablet}
      onClick={onClearAll}
      icon={<IconTrash size={isMobile ? 16 : isTablet ? 18 : 20} />}
      label={t('header.clearAll')}
      color="red"
      variant="light"
    />
  );
};
